<component v-if="componentExtactor" :is="componentExtactor" v-bind="params" :close="close"></component>